import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AlertBox from "../../component/AlertBox";
import { LinearProgress } from "@mui/material";
import ButtonCompo from "../../component/ButtonCompo";
import InputField from "../../component/InputField";
import { useForm } from "react-hook-form";
import SelectField from "../../component/SelectField";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { DatePicker } from "@mui/x-date-pickers";
import axios from "axios";
import { SERVER_URL } from "../../constant";
import dayjs from "dayjs";

function SAOnboardingEmployee() {
  const isSuperadmin = useSelector(
    (state) => state.superadmin?.isSuperadminAuthenticated
  );
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [allProjects, setAllProjects] = useState([]);
  const [managers, setManagers] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedManager, setSelectedManager] = useState("");
  const [selectedGender, setSelcetdGender] = useState("")
  const [dob, setDob] = useState(new Date());
  const [startShieft, setStartShieft] = useState();
  const [endShieft, setEndShieft] = useState();

  // salary calculation params
  const [basic, setBasic] = useState(0);
  const [ctc, setCtc] = useState(0);

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isSuperadmin !== undefined && isSuperadmin === false) {
      navigate("/superadmin/signin");
    }
  }, [isSuperadmin]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  // onboard employee
  async function employeeOnboard(data) {
    if (selectedManager?.length === 0) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please select a manager");
      return null;
    }
    if (dob?.$d === undefined) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please select the date of birth");
      return null;
    }
    if (startShieft?.$d === undefined || endShieft?.$d === undefined) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please select both shieft time");
      return null;
    }
    /* hey developer, do you remember that I merge
    two value in a string to set as "value" attribute of <option> ?
    I hope you do. Now, I am splitting the string two extract 
    two values differently from that string. */
    const splitedManagerValue = selectedManager?.split("-");
    // we need to check whether the value splitted well or not
    if (!Array.isArray(splitedManagerValue)) {
      setOpen(true);
      setSuccess(false);
      setMessage("Something went wrong");
      return null;
    }
    // structuring object for backend
    let postData = {
      ...data,
      dob: dob?.$d,
      managerId: splitedManagerValue[0],
      managerRole: splitedManagerValue[1],
      startShieftTime: new Date(startShieft?.$d).toLocaleTimeString(),
      endShieftTime: new Date(endShieft?.$d).toLocaleTimeString(),
      ctc: ctc,
      project: selectedProject,
      basic: basic,
      gender: selectedGender
    };
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/add/superadmin`,
        method: "post",
        data: postData,
        withCredentials: true,
      });
      if (res.status >= 200 || res.status < 400) {
        setOpen(true);
        setSuccess(true);
        setMessage("Employee onboarded successfully");
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  //fetch all projects
  async function getProjects() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/superadmin/get/projects`,
        method: "get",
        withCredentials: true,
      });
      // save the api data
      let rawData = res.data?.data;
      // go through every element
      let selectfieldData = rawData?.map((e) => {
        // structure the data as per selectfield data structure
        let newObj = {
          title: e,
          value: e,
        };
        return newObj;
      });
      setAllProjects(selectfieldData);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Projects fetch failed");
    } finally {
      setLoading(false);
    }
  }

  //fetch all managers
  async function getManagers() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/superadmin/get/all/managers`,
        method: "get",
        withCredentials: true,
      });
      //console.log(res.data?.data)
      let rawData = res.data?.data;
      let selectfieldData = [];
      rawData?.map((e) => {
        let newObj = {
          title:
            e?.managerRole === "CompanySuperadmin"
              ? `${e?.name}(Superadmin)`
              : e?.name, // add a extra reference for superadmin
          value: `${e?.mangerId}-${e?.managerRole}`, // we can't set object as "value" attribute of <option> tag but we can set string. I combine two data in a string.
        };
        selectfieldData.push(newObj);
      });
      setManagers(selectfieldData);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Projects fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // gender array
  const genderArray = [
    {
      title: "Male",
      value: "Male"
    },
    {
      title: "Female",
      value: "Female"
    },
    {
      title: "Others",
      value: "Others"
    },
  ]

  useEffect(() => {
    getProjects();
    getManagers();
  }, []);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center flex-col">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <h1 className="text-[30px] font-medium text-left w-full">
            Onboard An Employee
          </h1>
          <div className="mt-5 w-full">
            <form className="mt-5" onSubmit={handleSubmit(employeeOnboard)}>
              <div className="w-full">
                <p className="mb-5 font-medium text-[17px]">
                  Personal & Job Details
                </p>
                <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-10">
                  <InputField
                    label="Name *"
                    {...register("name", {
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                    error={errors?.name}
                  />
                  <InputField
                    label="Professional Email"
                    type="email *"
                    {...register("email", {
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                    error={errors?.email}
                  />
                  <InputField
                    label="Personal Email"
                    type="email"
                    {...register("personalEmail", {
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                    error={errors?.email}
                  />
                  <InputField
                    label="Role *"
                    {...register("role", {
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                    error={errors?.role}
                  />
                  <InputField
                    label="Designation *"
                    {...register("designation", {
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                    error={errors?.designation}
                  />
                  <InputField
                    label="Phone Number *"
                    {...register("phoneNumber", {
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      minLength: {
                        value: 10,
                        message:
                          "Phone number should not be less than 10 digits",
                      },
                      maxLength: {
                        value: 10,
                        message:
                          "Phone number should not be greater than 10 digits",
                      },
                      setValueAs: (value) => value.trim(),
                    })}
                    isImp={true}
                    error={errors?.phoneNumber}
                  />
                  <InputField
                    label="Probation Period(in months)"
                    {...register("probationPeriod", {
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                    error={errors?.probationPeriod}
                  />
                  <SelectField
                    label={<p>Manager <span className="text-red-600">*</span></p>}
                    value={selectedManager}
                    setValue={(e) => setSelectedManager(e?.target?.value)}
                    valueArray={managers}
                  />
                  <SelectField
                    label="Project"
                    value={selectedProject}
                    setValue={(e) => setSelectedProject(e?.target?.value)}
                    valueArray={allProjects}
                  />
                  <SelectField
                    label={<p>Gender <span className="text-red-600">*</span></p>}
                    value={selectedGender}
                    setValue={(e) => setSelcetdGender(e?.target?.value)}
                    valueArray={genderArray}
                  />
                  <InputField
                    label="Department"
                    {...register("department", {
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    })}
                    error={errors?.department}
                  />
                  <DatePicker
                    label={<p>Date of Birth <span className="text-red-600">*</span></p>}
                    onChange={(e) => setDob(e)}
                  />
                </div>
              </div>
              <div className="mt-5">
                {
                  <DemoContainer
                    components={["MobileTimePicker", "MobileTimePicker"]}
                  >
                    <div className="w-full">
                      <p className="text-[17px] font-medium">Shieft <span className="text-red-600">*</span></p>
                      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-10 mt-5">
                        <MobileTimePicker
                          label="From"
                          className="w-full"
                          onChange={setStartShieft}
                        />
                        <MobileTimePicker
                          label="To"
                          className="w-full"
                          onChange={setEndShieft}
                        />
                      </div>
                    </div>
                  </DemoContainer>
                }
              </div>
              <div className="mt-5 w-full flex justify-end items-end">
                <ButtonCompo variant={"contained"} type="submit">
                  onboard
                </ButtonCompo>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default SAOnboardingEmployee;
